import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { inject, Injectable } from '@angular/core';
import { globalStore } from '../../../../../modules/shared/shared.global-service';
import { selectFolder } from '../../../../../modules/content/store/person/person.selectors';
import { GlobalStore } from '../../../../../store/global.global-store';

@Injectable()
export class FolderEPrescriptionsPageStore extends ComponentStoreV2Factory {
    public readonly globalStore = inject(GlobalStore);
    folder = globalStore!.selectSignal(selectFolder);
    currentUser = this.globalStore.loggedUserStore.currentUser;
}
